/* eslint-disable */
import React, { useState } from 'react';
import RegisterBanner from './RegisterBanner';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Seo from "../Seo";

toast.configure()

const Emailsent = () => {

    return (
        <>
         <Seo
                path="/emailsent"
        />
            {/* <RegisterBanner /> */}
            <section id="contact" className="contact new-contact">
                <div className="container">



                    <div className="row">

                        <div className="col-lg-3 contact-sec" data-aos="fade-up" data-aos-delay="200">
                        </div>

                        <div className="col-lg-6">
                            <form action="" method="post" role="form" className="php-email-form">
                                <div className="row ">
                                    
                                    <div className="col-lg-12">
                                    <div className="text-center mg-ct section-title">
                                        <h2>Account Confirmation</h2>
                                    </div>
                                        <div className="text-center mg-ht">An email with your account confirmation link has been sent to your email.. Check your email and click on the link to activate your account..</div>

                                        
                                        <div className="text-center log-link">
                                            <Link className="sign mt-3" to="/login"> <div className="heya text-center">Log in</div></Link>
                                        </div>
                                    </div>

                                </div>





                            </form>
                        </div>
                        <div className="col-lg-3 contact-sec" data-aos="fade-up" data-aos-delay="200">

                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export default Emailsent;